interface CustomTemplatePayload {
  template_body: string
}

export const buildCustomTemplatePayload = (templateBody: string): CustomTemplatePayload => ({
  template_body: templateBody,
})
